import CheckboxTerms from './CheckboxTerms'

export default CheckboxTerms
